import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  div {
    width: 80%;
    padding: 0 137px;
  }

  button {
      padding: 15px;
      border-radius: 15px;
      margin: 0;
      width: 50%;
      background: #3FB4A8;
      color: #f6f6f6;
    }

  img {
    width: 500px;
  }

  section {
    width: 100%;
    padding: 0 137px;

    div {
      width: 900px;
      height: 506px;
    }
  }
`